<div>
  <div class="card-title">
    <span style="margin-right: 10px">{{ title }}</span>
    <span
      ><span
        size="sm"
        class="fas fa-angle-right horizontal-spacing clickable"
        (click)="UpdateAllTradeableBankBalances()"
        *ngIf="showRunButton"
        mdbTooltip="Run update"
      >
      </span>
      <span
        class="fas fa-xmark horizontal-spacing clickable"
        (click)="CancelUpdateBankBalanceProcess()"
        mdbTooltip="Cancel process"
        *ngIf="showCancelButton"
      ></span>
      <span class="far fa-copy horizontal-spacing clickable" (click)="copyReport()" mdbTooltip="{{ copyTooltip }}"></span>
    </span>
  </div>

  <div *ngIf="processingMessage.length > 0" class="alert alert-info text-center font-weight-bold small" role="alert">
    <div class="spinner-grow text-primary" size="sm" role="status" *ngIf="cancelling">
      <span class="sr-only" role="status">Loading...</span>
    </div>
    {{ processingMessage }}
  </div>
  <div class="alert alert-danger text-center font-weight-bold" role="alert" *ngIf="errorMessage.length > 0">Error: {{ errorMessage }}</div>

  <div *ngIf="progressReportVisible; else notRunning">
    <div class="spacing small">
      <div *ngIf="progressReport.startTime">
        Started:
        {{ progressReport.startTime | date: dateFormat }}
      </div>
      <div *ngIf="progressReport.endTime">Ended: {{ progressReport.endTime | date: dateFormat }}</div>
      <div class="spacing">
        <div>Total: {{ progressReport.total }}</div>
        <div>Failures: {{ progressReport.errors.length }}</div>
      </div>
    </div>
    <div class="text-center">
      <div class="progress spacing">
        <div
          class="progress-bar progress-bar-striped"
          role="progressbar"
          [style]="computeWidth()"
          [aria-valuenow]="progressReport.percentComplete"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div class="spacing small">{{ progressReport.percentComplete }}% Complete</div>
      <div class="spacing small">
        Updating:
        <span *ngFor="let detail of progressReport.details"
          ><span *ngIf="detail.fullName.startsWith('A'); else not_the_start">{{ detail }}</span
          ><ng-template #not_the_start
            ><span>, {{ detail }}</span></ng-template
          >
        </span>
      </div>
      <div class="small scrollable-box overflow-auto">
        <p class="error" *ngFor="let error of progressReport.errors">
          {{ error }}
        </p>
      </div>
    </div>
  </div>
  <ng-template #notRunning><div class="spacing small">Update not running</div></ng-template>
</div>
